import type { ApolloQueryResult, OperationVariables } from '@apollo/client';
import { createContext } from 'react';

/**
 * Type for Apollo Client's refetch function
 * This is the standard signature for refetch returned by useQuery
 */
type RefetchFunction<TData = unknown, TVariables extends OperationVariables = OperationVariables> = (
  variables?: Partial<TVariables>,
) => Promise<ApolloQueryResult<TData>>;

/**
 * Context type for ActionDialogContext
 * Used to provide refetch capability to action dialogs that need to refresh data after mutations
 */
interface ActionDialogContextType {
  /**
   * Apollo refetch function to refresh query data after an action completes
   * null when no refetch is available (default state)
   */
  refetch: RefetchFunction | null;
}

const defaultValue: ActionDialogContextType = {
  refetch: null,
};

export const ActionDialogContext = createContext<ActionDialogContextType>(defaultValue);

export type { ActionDialogContextType, RefetchFunction };
